/*
  FWUSA motion: scroll reveals (.fw-reveal) and the tagline word reveal ([data-fw-tagline]).
  Uses IntersectionObserver only, never a scroll listener. Each element reveals once.
  With reduced motion or in the theme editor everything is shown at once.
*/
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function showAll(scope) {
    scope.querySelectorAll(".fw-reveal").forEach(function (el) { el.classList.add("is-visible"); });
    scope.querySelectorAll("[data-fw-word]").forEach(function (el) { el.classList.add("is-on"); });
  }

  function init(scope) {
    if (reduceMotion || designMode || !("IntersectionObserver" in window)) {
      showAll(scope);
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });
    scope.querySelectorAll(".fw-reveal:not(.is-visible)").forEach(function (el) { revealObserver.observe(el); });

    // Each word lights up as it crosses a line 35% above the bottom of the screen.
    var wordObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-on");
        wordObserver.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -35% 0px", threshold: 1 });
    scope.querySelectorAll("[data-fw-word]:not(.is-on)").forEach(function (el) {
      // Words already scrolled past (page opened further down) start lit.
      if (el.getBoundingClientRect().bottom < 0) { el.classList.add("is-on"); return; }
      wordObserver.observe(el);
    });
  }

  init(document);
  document.addEventListener("shopify:section:load", function (event) { showAll(event.target); });

  // Text size control (sections/fw-utility-bar.liquid). The choice is remembered per visitor.
  var SIZES = ["normal", "large", "largest"];
  var NAMES = { normal: "Standard", large: "Larger", largest: "Largest" };
  function readSize() { try { return localStorage.getItem("fw-text-size"); } catch (e) { return null; } }
  function applySize(size) {
    if (SIZES.indexOf(size) === -1) size = "normal";
    if (size === "normal") document.documentElement.removeAttribute("data-text-size");
    else document.documentElement.setAttribute("data-text-size", size);
    document.querySelectorAll("[data-fw-text-size] button[data-size]").forEach(function (btn) {
      btn.setAttribute("aria-pressed", String(btn.dataset.size === size));
    });
    // Phones show one button that steps through the sizes; its label names the current one.
    document.querySelectorAll("[data-fw-text-size-cycle]").forEach(function (btn) {
      var label = btn.getAttribute("aria-label").split(":")[0];
      btn.setAttribute("aria-label", label + ": " + NAMES[size]);
      btn.dataset.current = size;
    });
  }
  applySize(readSize());
  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest("[data-fw-text-size] button");
    if (!btn) return;
    var size = btn.hasAttribute("data-fw-text-size-cycle")
      ? SIZES[(SIZES.indexOf(btn.dataset.current || "normal") + 1) % SIZES.length]
      : btn.dataset.size;
    applySize(size);
    try { localStorage.setItem("fw-text-size", size); } catch (e) { /* storage blocked: size still applies for this page */ }
  });
})();
